import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import { getMatrixClient } from 'ducks/chat/utils/client'
import FolderCollection from './Collection'
import styles from './styles.less'

export default function Folders({
  collections,
  type,
  isBootstrapped,
  onBootstrap,
  isMatrixClientReady,
}) {
  const [hasTriggeredBootstrap, setHasTriggeredBootstrap] = useState(false)
  useEffect(
    () => {
      if (
        onBootstrap &&
        isBootstrapped &&
        !hasTriggeredBootstrap &&
        isMatrixClientReady
      ) {
        onBootstrap(getMatrixClient())
        setHasTriggeredBootstrap(true)
      }
    },
    [
      onBootstrap,
      isBootstrapped,
      hasTriggeredBootstrap,
      setHasTriggeredBootstrap,
      isMatrixClientReady,
    ]
  )

  return (
    <div
      className={cn({
        [styles['unified-compact']]: false,
      })}
    >
      {collections
        .filter(({ type: collectionType }) => collectionType === type)
        .map(({ id }) => <FolderCollection key={id} collectionId={id} />)}
    </div>
  )
}
